import * as React from 'react';

import { FormHelperText } from '@mui/material';
import { loginByPhone } from '@realadvisor/auth-client';

import { useLocale } from '@legacy/hooks/locale';
import { getAfterLoginHref } from '@legacy/routes/Login/loginRedirects';
import { PinInput } from '@legacy/routes/Login/PinInput';

type Props = {
  phone: string;
  tenantId: string | null;
};

export const LoginVerifyCodeForm = (props: Props) => {
  const { t } = useLocale();
  const [{ error, commitIndex }, dispatch] = React.useReducer(
    (state: { error: null | string; commitIndex: number }, error: string) => ({
      error,
      commitIndex: state.commitIndex + 1,
    }),
    { error: null as null | string, commitIndex: 0 },
  );
  return (
    <>
      <PinInput
        key={commitIndex}
        length={4}
        label={t('enterSMSCode')}
        onChange={code => {
          loginByPhone({
            // normalize phone for db request
            number: props.phone.replace(/[^+\d]/g, ''),
            code,
            tenantId: props.tenantId,
          }).then(async response => {
            if (response.ok) {
              location.href = getAfterLoginHref(props.tenantId);
            } else if (response.status >= 400) {
              const result = await response.json();
              let message = t('somethingWentWrong');
              if (result.error === 'EXPIRED_CODE') {
                message = t('authPhoneExpired');
              }
              if (result.error === 'WRONG_CODE') {
                message = t('authPhoneWrongCode');
              }
              if (result.error === 'WRONG_CODE_TOO_MANY_TIMES') {
                message = t('authPhoneWrongCodeManyTimes');
              }
              dispatch(message);
            }
          });
        }}
      />
      {error != null && <FormHelperText error={true}>{error}</FormHelperText>}
    </>
  );
};
